import React from 'react';
import { Link } from 'react-router-dom';
import { useDarkMode } from '../../context/DarkModeContext';
import { PlusIcon, LockIcon, GlobeIcon, MoreVerticalIcon } from 'lucide-react';
const BookLists = () => {
  const {
    darkMode
  } = useDarkMode();
  const lists = [{
    id: 1,
    title: 'TBR - Fall 2023',
    bookCount: 12,
    isPrivate: false,
    covers: ['https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800', 'https://images.unsplash.com/photo-1516979187457-637abb4f9353?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800', 'https://images.unsplash.com/photo-1598646506899-ac6be1060f4b?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800']
  }, {
    id: 2,
    title: 'Favorite Romances',
    bookCount: 45,
    isPrivate: true,
    covers: ['https://images.unsplash.com/photo-1515876305430-f06edab8282a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800', 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=800']
  }];
  return <div className={`min-h-screen ${darkMode ? 'bg-gray-900 text-gray-100' : 'bg-gray-50 text-gray-900'} py-8`} data-id="element-12241" data-mp="2sgukgfildawq">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-12242" data-mp="2dmzf3jhna3qa">
        <div className="flex justify-between items-center mb-8" data-id="element-12243" data-mp="2iiyavs5ayo0q">
          <h1 className="text-3xl font-bold" data-id="element-12244" data-mp="24surd8xt58ez">My Book Lists</h1>
          <button className="flex items-center px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 transition-colors" data-id="element-12245" data-mp="24r9uvdrxnfeh">
            <PlusIcon className="h-5 w-5 mr-2" data-id="element-12246" data-mp="1uund4xuwl4go" />
            Create List
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-12247" data-mp="1zt8cyw68tm4l">
          {lists.map(list => <div key={list.id} className={`rounded-xl shadow-sm overflow-hidden ${darkMode ? 'bg-gray-800' : 'bg-white'} hover:shadow-md transition-shadow`} data-id="element-12248" data-mp="1ltgvglgipnlu">
              {/* Cover Preview Grid */}
              <div className="h-48 bg-gray-200 grid grid-cols-3 gap-1 p-1" data-id="element-12249" data-mp="3sjag3t7iyye7">
                {list.covers.slice(0, 3).map((cover, idx) => <img key={idx} src={cover} alt="" className="w-full h-full object-cover" data-id="element-12250" data-mp="3irmtq6pts7jl" data-mpi={idx} />)}
                {[...Array(3 - list.covers.slice(0, 3).length)].map((_, idx) => <div key={`empty-${idx}`} className={`w-full h-full ${darkMode ? 'bg-gray-700' : 'bg-gray-300'}`} data-id="element-12251" data-mp="ac35jm40hfbe" data-mpi={idx}></div>)}
              </div>

              <div className="p-4" data-id="element-12252" data-mp="1dr56sdcf35r">
                <div className="flex justify-between items-start" data-id="element-12253" data-mp="2q38rtfvm8r2r">
                  <div data-id="element-12254" data-mp="2q1eb6drdnl4h">
                    <h3 className="text-lg font-bold mb-1" data-id="element-12255" data-mp="2m25dixt7v33n">{list.title}</h3>
                    <p className={`text-sm ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-12256" data-mp="2m49sqbwkfoj8">
                      {list.bookCount} books
                    </p>
                  </div>
                  <button className={`p-1 rounded-full ${darkMode ? 'hover:bg-gray-700' : 'hover:bg-gray-100'}`} data-id="element-12257" data-mp="1ak16onroo6zj">
                    <MoreVerticalIcon className="h-5 w-5 text-gray-500 dark:text-gray-400" data-id="element-12258" data-mp="1fckk9kqdf24c" />
                  </button>
                </div>

                <div className="mt-4 flex items-center justify-between" data-id="element-12259" data-mp="1p976acufnz7y">
                  <div className={`flex items-center text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`} data-id="element-12260" data-mp="1pba2xfq3cqln">
                    {list.isPrivate ? <>
                        <LockIcon className="h-3 w-3 mr-1" data-id="element-12261" data-mp="3v2nl3m3f93n6" /> Private
                      </> : <>
                        <GlobeIcon className="h-3 w-3 mr-1" data-id="element-12262" data-mp="3wmg9va1v69z" /> Public
                      </>}
                  </div>
                  <Link to={`/lists/${list.id}`} className="text-sm font-medium text-indigo-600 hover:text-indigo-500" data-id="element-12263" data-mp="2zs8xwbbtn6k4">
                    View List
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
};
export default BookLists;